export class ReportUnoccupiedDaysDto {
  id: string;
  userId: string;
  username: string;
  firstName: string;
  lastName: string;
  operativeUnitId: string;
  operativeUnitCode: string;
  operativeUnitName: string;
  emptyDateKeys: string[];
  emptyDays: string;
  emptyDaysCount: number;
  firstEmptyDate: string;
}
